
export const CHECKOUT_TYPES = {
    BULK_PAY: 'BULK_PAY',
    SINGLE: 'SINGLE',
    MILESTONE: 'MILESTONE'
};

export const AMOUNT_SELECTION_STEP = 'AMOUNT_SELECTION';
export const PAYNENT_METHOD_SELECTION_STEP = 'PAYNENT_METHOD_SELECTION';
export const PAYMENT_METHOD_STEP = 'PAYMENT_METHOD';
export const PAYMENT_CONFIRMATION_STEP = 'PAYMENT_CONFIRMATION';
export const QUICK_PAY_STEP = 'QUICK_PAY';

export const CHECKOUT_AMOUNT = {
    TOTAL_PAST_DUE: 'total_past_due',
    TOTAL_DUE: 'total_due',
    TOTAL_OPEN_BALANCE: 'total_open_balance'
};

export const PAYMENT_METHOD_CARD_PROCESSING_CLASS_NAME = "PaymentMethodCardProcessing";